<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LQNMPd/tc-custom/9781504071673.jpg?1742443248379" alt="This image is the cover for the book Convent, The Sister Veronica Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Convent, The Sister Veronica Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A London nun and whodunit writer finds herself enmeshed in a sinister murder plot in this mystery series debut.</b><br/><br/> Meet Sister Veronica Angelica, a secret crime fiction writer and lover of custard cream biscuits.</p><p>When she discovers a dead man in the grounds of the Catholic Youth Hostel, next door to her convent, she can see he’s been brutally murdered. What she doesn’t know, is that Jamie had a secret he’d been about to confess . . .<br/><br/> Being forbidden by the Cardinal to contact the police, the nuns at the Convent of the Christian Heart are instructed to contain news of the murder. Then, as Sister Veronica tries to uncover the truth, another murder takes place, plunging her deeper into the mystery.<br/><br/> But when her investigation raises more questions than answers, will Sister Veronica be able to solve the case without attracting the killer’s attention?<br/><br/><b>A compelling mystery perfect book for fans of Ann Cleeves’s Vera Stanhope series, as well as fans of authors like Faith Martin and J.R. Ellis.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Sheridan
      </h2>
      
      <p class="authorDescription body article">Sarah was born in London and now lives in a village in South Northamptonshire. She gained a Masters degree in Eighteenth-Century French and English art from the Courtauld Institute of Art, before teaching art in secondary schools for thirteen years. After working with human rights organisations that protect minority groups from institutional abuse, Sarah worked towards a PhD at The Open University, researching the effect of secrecy on marginalised people, specifically the biological children of Roman Catholic priests. She has spoken about her research on various news programmes for the BBC and other media outlets around the world. It was this sense of secrecy and silencing that became the inspiration for her first crime novel, The Convent.   Sarah is hugely obsessed with reading and is amassing such an unrealistically large book collection that some of it is now in storage. She is also addicted to writing, and after inventing stories (mostly in secret) from a young age and having various articles and short stories published, she wrote a children's book, The Top Secret Diary of Davina Dupree - inspired by her daughter -  in 2013. Overjoyed to hear that young readers were enjoying the story, she went on to write a series about Davina Dupree.   When she is not looking after her three children and menagerie of pets, or going for long walks with her wonderful partner Rich, Sarah can be found writing, while consuming large amounts of chocolate.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71c3e2a6